<template>
    <div class="rangebox-wrapper">
        <el-form :model="range" size="small" label-position="right" hide-required-asterisk>
            <el-form-item prop="min" label="匹配系数：" class="matchBox-left">
                <el-input class="input-left" v-model="range.start" maxlength="4" clearable />
            </el-form-item>
            <span class="strip">~</span>
            <el-form-item prop="max" class="matchBox-right">
                <el-input class="input-right" v-model="range.end" maxlength="4" clearable />
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            range: { start: "", end: "" }
        };
    },
    watch: {
        range: {
            handler() {
                this.$emit("change", this.range);
            },
            deep: true
        }
    },
    methods: {}
};
</script>

<style scoped lang="less">
.rangebox-wrapper {
    line-height: 33px;
    display: inline-block;
    vertical-align: top;
}
.el-form {
    display: flex;
    width: 219px;
    height: 32px;
    justify-content: left;
    flex-wrap: wrap;
}
.matchBox-left {
    width: 130px;
    margin-right: 3px;
    .el-form-item__label {
        font-weight: 200;
        padding-left: 10px;
    }
}
.matchBox-right {
    margin-left: 5px;
}
.input-left,
.input-right {
    width: 65px;
    margin-left: -15px;
}
.strip {
    display: inline-block;
    margin: 0 13px 0 -12px;
}
</style>
